import api from '@/shared/api';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useIntl } from 'react-intl';
import config from '@/config';
import handleHttpError from '@/shared/services/HandleHttpError';
import { SettingsQueryKey } from './queryKey';
export const useUpdateDocumentSettings = () => {
    const intl = useIntl();
    const queryClient = useQueryClient();
    const { mutateAsync, isLoading } = useMutation((model) => api.base
        .put(`${config.appUrls.documents}/api/settings/`, model)
        .then(res => res.data), {
        onSuccess: (result) => {
            queryClient.setQueryData([SettingsQueryKey.DocumentSettings], result);
        },
        onError: (apiError) => {
            handleHttpError(intl)(apiError);
        },
    });
    return { updateDocumentSettings: mutateAsync, isLoading };
};
